const translate = (literal: string, props: Record<string, string> = {}): string => {
  if (window.Convermax.translate) {
    return window.Convermax.translate(literal, props);
  }

  let localizedLiteral =
    window.Convermax.translations?.[literal] ?? window.Convermax.defaultTranslations[literal] ?? '';

  Object.entries(props).forEach(([key, value]) => {
    localizedLiteral = localizedLiteral.replaceAll(
      // remove all curly brackets around the replaced variable
      new RegExp(`\\{{1,2}\\s*(?:this\\.)?${key}\\s*\\}{1,2}`, 'g'),
      value,
    );
  });

  return localizedLiteral;
};

export default translate;
